import { useState } from 'react';
import { featuredCards } from '@/mocks/kanliao';

const colorMap: Record<string, string> = {
  amber: 'from-amber-400 to-yellow-500',
  orange: 'from-orange-400 to-rose-500',
  rose: 'from-rose-400 to-pink-500',
  emerald: 'from-emerald-400 to-teal-500',
  stone: 'from-stone-400 to-stone-500',
};

const quickWords = ['影视', '番剧', '短剧', '网盘', '直播', '高清'];

export default function HeroCards() {
  const [kw, setKw] = useState('');
  const filtered = featuredCards.filter(
    (c) => c.title.includes(kw.trim()) || c.desc.includes(kw.trim()),
  );
  const list = kw.trim() ? filtered : featuredCards;

  return (
    <section id="hero" className="relative overflow-hidden">
      <div className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-amber-200/40 blur-3xl" />
      <div className="pointer-events-none absolute -left-20 top-40 h-64 w-64 rounded-full bg-orange-200/40 blur-3xl" />

      <div className="relative mx-auto w-full max-w-[1200px] px-4 pb-12 pt-12 md:px-6 md:pt-16">
        <div className="mx-auto flex w-full max-w-3xl flex-col items-center text-center">
          <span className="inline-flex items-center gap-1.5 rounded-full border border-amber-200 bg-white/70 px-3 py-1 text-xs font-medium text-orange-700">
            <i className="ri-flashlight-fill text-amber-500" />
            今日已收录 128 条新入口 · 持续补充中
          </span>
          <h1 className="mt-5 text-3xl font-black leading-tight tracking-tight text-stone-900 md:text-[44px]">
            热门站点一键直达，<br className="md:hidden" />
            <span className="bg-gradient-to-r from-orange-500 to-rose-500 bg-clip-text text-transparent">
              看料不迷路
            </span>
          </h1>
          <p className="mt-4 max-w-xl text-sm leading-relaxed text-stone-500 md:text-base">
            <strong className="font-semibold text-stone-700">看料网址导航</strong>与
            <strong className="font-semibold text-stone-700">地址汇总</strong>，分类清晰直达想看的内容，
            一个入口替代反复搜索，收藏这一个就够用了。
          </p>

          <div className="mt-7 w-full max-w-xl">
            <div className="flex w-full items-center gap-2 rounded-xl border border-amber-200 bg-white p-1.5">
              <i className="ri-search-line pl-2 text-xl text-stone-400" />
              <input
                value={kw}
                onChange={(e) => setKw(e.target.value)}
                placeholder="输入想看的类别，直达筛选结果"
                className="w-full min-w-0 bg-transparent text-sm outline-none placeholder:text-stone-300"
              />
              <button
                type="button"
                className="whitespace-nowrap rounded-lg bg-orange-500 px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-orange-600"
              >
                直达
              </button>
            </div>
            <div className="mt-3 flex flex-wrap items-center justify-center gap-2">
              <span className="whitespace-nowrap text-xs text-stone-400">试试：</span>
              {quickWords.map((w) => (
                <button
                  key={w}
                  type="button"
                  onClick={() => setKw(w)}
                  className="whitespace-nowrap rounded-full border border-stone-200 bg-white px-3 py-1 text-xs text-stone-500 transition-colors hover:border-orange-300 hover:text-orange-600"
                >
                  {w}
                </button>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-5">
          {list.map((c) => (
            <a
              key={c.title}
              href="#hero"
              className="group flex flex-col justify-between rounded-xl border border-stone-200/80 bg-white/80 p-4 transition-all hover:-translate-y-0.5 hover:border-orange-200 hover:bg-white"
            >
              <div className="flex items-start justify-between">
                <span
                  className={`inline-flex h-10 w-10 items-center justify-center rounded-lg bg-gradient-to-br text-white ${colorMap[c.accent]}`}
                >
                  <i className={`${c.icon} text-xl`} />
                </span>
                <span className="whitespace-nowrap rounded-full bg-amber-50 px-2 py-0.5 text-[10px] font-medium text-orange-600">
                  {c.meta}
                </span>
              </div>
              <div className="mt-4">
                <h3 className="text-sm font-bold text-stone-800">{c.title}</h3>
                <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-stone-500">{c.desc}</p>
              </div>
              <span className="mt-3 inline-flex items-center gap-1 text-xs font-medium text-orange-500">
                点此直达
                <i className="ri-arrow-right-up-line transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </span>
            </a>
          ))}
        </div>

        <p className="mt-4 text-center text-xs text-stone-400">
          分类清晰、入口随点随开，打不开的地址会尽快补充新入口，免去反复搜索的麻烦。
        </p>
      </div>
    </section>
  );
}